<template>
  <div class="card-203 text-center">

    <m-img class="card-203-image rounded-circle p-1" :alt="alt" :src="image"/>
    <div class="text-center card-203-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import mImg from "../Tags/Img";
import {CardProps} from "../Cards/CardProps";
import mA from "../Tags/A";

export default {
  name: "Card203.vue",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps,
  },
}
</script>

<style scoped>
.card-203 {
  width: 100%;
  transition: .2s ease-in-out all;
}

.card-203-image {
  width: 75px;
  height: 75px;
  border: 1px solid var(--primary);
  box-sizing: border-box;
  transition: .1s ease-in-out all;
  object-fit: cover;
}

.card-203-image:hover {
  border: 3px solid var(--secondary);
  box-sizing: border-box;
  transition: .1s ease-in-out all;
}

</style>